function Reversi() {
  return (
    <>
      <h2 id="reversi">Reversi (2017)</h2>
      <p>
        This is a large independent assignment in my first year university
        course Computer Fundamentals (APS105), programmed in C. This program is
        text-based and displays on the console with CodeLite IDE. It plays a
        Reversi game between the user and a computer AI algorithm. It also
        played my AI vs. the professor's AI, which is part of the assignment.
      </p>
      <p>
        The board's size is set at the beginning of the game. The user enters
        the coordinates to place their piece. B represents black, W represents
        white and U represents an empty square.
      </p>
      <p>
        The project file is{" "}
        <a
          href="https://1drv.ms/u/s!Arlw0YD7zqYNhmM6V1vVMmXx6U5y"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>
      <img
        alt="reversiterminal"
        src="https://1drv.ms/i/c/0da6cefb80d170b9/UQS5cNGA-86mIIANeCYAAAAAAEHxGCnNvnrQbWo?width=605&height=438"
      />
      <div>The terminal screen during a human vs AI game.</div>
      <br />
      <img
        alt="reversicode"
        src="https://1drv.ms/i/c/0da6cefb80d170b9/UQS5cNGA-86mIIANdyYAAAAAAGW-m_ElJUt0xP8?width=786&height=593"
      />
      <div>The CodeLite IDE.</div>
    </>
  );
}

export default Reversi;
